import axios from 'axios';
import { useState, useEffect } from 'react';
import Cookies from 'js-cookie';

import { URLS, SHOPIFY_STORES } from '../../config';
import { hooks } from '../../hooks';
import { theme } from '../../constants';
import { components } from '../../components';
// actions import removed (unused)
import masterBookData from '../../data/books-data.json'; 

export const WishlistEmpty: React.FC = () => {

  // const dispatch = hooks.useAppDispatch(); // unused
  const navigate = hooks.useAppNavigate();
  const [purchasedProducts, setPurchasedProducts] = useState<any[]>([]);

  const [loading, setLoading] = useState<boolean>(true);
  const [productsData, setProductsData] = useState<any>([]);

  const getData = async () => {
    setLoading(true);

    try {
      const products = await axios
        .get(URLS.GET_PRODUCTS)
        .then(res => res.data.products);

      // Note: banners and carousel data are fetched but not used, 
      // which is fine but good to know for code cleanup later.
      // banners and carousel are fetched for parity with other pages but not used
      await axios.get(URLS.GET_BANNERS).then(() => {});
      await axios.get(URLS.GET_CAROUSEL).then(() => {});

      setProductsData(products);
    } catch (error) {
      console.error("Error fetching general data:", error);
    } finally {
      // Keep loading true until both data fetching processes are complete if needed, 
      // but for now, it's fine here as long as fetchPurchasedProducts is also awaited 
      // or loading state is managed globally.
      // setLoading(false); 
    }
  };

  const fetchPurchasedProducts = async () => {
    const tokenFromLocal = typeof window !== 'undefined' ? localStorage.getItem('customerAccessToken') : null;
    const tokenFromCookie = Cookies.get('customerAccessToken');
    const token = tokenFromLocal || tokenFromCookie;

    if (!token) {
      setLoading(false); // Set loading to false if no token
      return;
    }
const storeKey = localStorage.getItem('loggedInStoreKey') || Cookies.get('loggedInStoreKey') || 'USA';
    
    // Get the store configuration (URL and Access Token)
    const storeConfig = SHOPIFY_STORES[storeKey as keyof typeof SHOPIFY_STORES] || SHOPIFY_STORES.USA;

    // Determine the JSON field to use for matching based on the logged-in store.
    const shopifyIdKey = storeKey === 'IN' ? 'shopify_product_id_IN' : 'shopify_product_id_US';
    const query = `
      query getCustomerOrders($customerAccessToken: String!) {
        customer(customerAccessToken: $customerAccessToken) {
          orders(first: 10, reverse: true) {
            edges {
              node {
                lineItems(first: 10) {
                  edges {
                    node {
                      title
                      quantity
                      variant {
                        image {
                          url
                        }
                        price {
                          amount
                        }
                        product {
                          id
                          title
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    `;

    try {
      const response = await fetch('https://festivehq.myshopify.com/api/2025-07/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': storeConfig.token,
        },
        body: JSON.stringify({ query, variables: { customerAccessToken: token } }),
      });

      const result = await response.json();
      const orders = result?.data?.customer?.orders?.edges || [];

      const products: any[] = [];

      orders.forEach((order: any) => {
  order.node.lineItems.edges.forEach((line: any) => {
    const p = line.node.variant?.product;
    if (!p || !p.id) return;

    const shopifyGlobalId = p.id;
    let shopifyNumericId: string | undefined;

    if (typeof shopifyGlobalId === 'string') {
      shopifyNumericId = shopifyGlobalId.split('/').pop();
    } else {
      console.warn('Shopify Global ID is not a string:', shopifyGlobalId);
      return;
    }

  const matchingBook = masterBookData.find(
      (book: any) => book[shopifyIdKey] === shopifyNumericId
    );
    
    // --- START BUNDLE LOGIC UPDATE ---
    if (matchingBook) {
        // Check if the matching item in your master data is a bundle
        if (matchingBook.issues && Array.isArray(matchingBook.issues)) {
            // If it is a bundle, add each individual issue to the products array
            matchingBook.issues.forEach((issue: any) => {
                products.push({
                   id: issue[shopifyIdKey] || matchingBook[shopifyIdKey], // Use issue's ID if available
                    title: issue.issue_title,
                    image: issue.image_url,
                    bookPath: issue.book_images_json_path, // This now points to a single issue
                });
            });
        } else {
            // It's a single product/issue, add it directly
            products.push({
              id: matchingBook[shopifyIdKey],
                title: matchingBook.title,
                image: matchingBook.image_url,
                bookPath: matchingBook.book_images_json_path,
            });
        }
    }
  });
      });

      setPurchasedProducts(products);
    } catch (err) {
      console.error(' Error fetching purchased products:', err);
    } finally {
      setLoading(false); // Set loading to false once data is processed
    }
  };


  useEffect(() => {
    // Await all data fetching before setting loading=false, or manage state carefully.
    // Given the current structure, let's call them sequentially, but allow fetchPurchasedProducts
    // to handle the final setLoading(false) state.
    getData(); 
    fetchPurchasedProducts();
    window.scrollTo(0, 0);
  }, []);


   const renderHeader = (): JSX.Element => {
        return <components.Header goBack={true} line={true} basket={true} />;
    };

  
 const renderContent = (): JSX.Element => {
    if (loading) return <components.Loader />;

    return (
      <div 
        style={{ 
            // FIX: Added top padding to clear the sticky Header
            padding: '40px 15px 20px 15px', 
            width: '100%',
            flex: 1,
            overflowY: 'auto',
            overflowX: 'hidden',
        }}
      >

<div><h2 style={{
          fontSize: 28,
          textAlign: 'center',
          fontWeight: 'bold',
          color: theme.colors.mainColor,
          margin: '0 0 18px 0', 
          letterSpacing: 1,
          ...theme.fonts.Mulish_700Bold,
 }}>Library</h2></div>
<h2
          style={{
            textAlign: 'center',
            margin: 0,
            marginBottom: 20,
            fontFamily: theme.fonts.Mulish_700Bold.fontFamily,
            fontWeight: 'bold',
            fontSize: 22,
            lineHeight: 1.3,
            textTransform: 'capitalize',
            color: theme.colors.mainColor,
          }}
        >
Welcome to Your Library!
</h2>

 {purchasedProducts.length > 0 ? (
          <div
            style={{ 
              display: 'grid',
              gridTemplateColumns: 'repeat(2, 1fr)',
              gap: '20px',
              marginBottom: 40,
            }}
          >
         {purchasedProducts.map((item, index) => (
              <div key={item.id}>
                
                <button
                  onClick={() => {
                    try {
                      if (!item.bookPath || typeof item.bookPath !== 'string') {
                        console.error('bookPath is undefined or not a string for item:', item.title);
                        return;
                      }
                      
                      const bookIdFromPath = item.bookPath.split('/').pop()?.replace('.json', '');
                      if (bookIdFromPath) {
                        navigate(`/BookViewer/${bookIdFromPath}`);
                      } else {
                        console.error('Could not extract book ID from path:', item.bookPath);
                      }
                    } catch (error) {
                      console.error('Error navigating to BookViewer:', error);
                    }
                  }}
                    style={{ padding: 0, border: 'none', background: 'none', display: 'block', width: '100%' }}
                >
                  <img
                    src={item.image}
                    alt={item.title}
                    style={{
                        width: '100%', 
                        height: 'auto',
                        borderRadius: '12px',
                        objectFit: 'cover',
                        boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
                    }}
                  />
                </button>
 <p
style={{
                    fontSize: 14,
                    marginTop: 8,
                    textAlign: 'center', 
                    ...theme.fonts.Mulish_600SemiBold,
color: theme.colors.mainColor,
 }}
 >
{item.title} 
 </p>
 </div>
))}
</div>
 ) : (
<p style={{ textAlign: 'center', color: theme.colors.textColor }}>
            You haven't purchased anything yet.
          </p>
        )}
      </div>
    );
  };


  const renderBottomTabBar = () => {
    return <components.BottomTabBar />;
  };

  return (
    <>
      {renderHeader()}
      {renderContent()}
      {renderBottomTabBar()}
    </>
  );
};





